<template>
  <v-app :class="{['optima-' + theme]: true}">
    <component :is="layout" :optima-theme="theme">
      <router-view />
    </component>
  </v-app>
</template>

<script>
export default {
  name: "App",
  async mounted() {
    await this.$store.dispatch("authAction");
  },
  data() {
    return {
      drawer: null,
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
    theme() {
      return this.$route.meta.theme || 'light';
    }
  },
};
</script>
